<form *ngIf="isVersion2()" name="tableItemEditForm" #tableItemEditForm="ngForm">
  <div class="row">
    <!--<div class="col-sm-8">
    <div class="form-group">
      <label for="Entity"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.Entity' | translate}}</label>
      <input class="form-control" type="text"
             placeholder="{{'Placeholders.CardEffectivityMap.EffectivityTableEdit.Entity' | translate}}"
             [(ngModel)]="item.entity" name="entity" #entity="ngModel" maxlength="60"
             required>
      <validation-message [control]="entity"></validation-message>
    </div>
  </div>-->

    <div class="col-sm-4">
      <div class="form-group">
        <label for="EntityCode" [class.disabled]="origin === 'AC'">
          <span *ngIf="origin !== 'AC'" class="mandatory">*</span>
          {{'CardEffectivityMap.EffectivityTableEdit.GroupOfEntities' | translate}}
        </label>
        <select class="custom-select" [(ngModel)]="item.entityCode" name="entityCode"
                (ngModelChange)="changedEntity()"
                #entityCode="ngModel"
                [disabled]="origin === 'AC'"
                [required]="origin !== 'AC'"
                [dropdownTitle]="{value : item.entityCode }"
                [clearRelated]="{model : this.item , propsToReset : ['subscriberSituationCode', 'otherEntity']}"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of entities" [value]="domain.type">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="entityCode"></validation-message>
      </div>
    </div>

    <div class="col-sm-8" >
      <div class="form-group">
        <label [class.disabled]="origin === 'AC'" for="OtherEntity">
          <span *ngIf="item.entity === 'Outra'" class="mandatory">*</span>
          {{'CardEffectivityMap.EffectivityTableEdit.Entity' | translate}}
        </label>
        <textarea class="form-control" id="otherEntity" [(ngModel)]="item.otherEntity"
                  #otherEntity="ngModel"
                  [required]="item.entity === 'Outra'"

                  name="otherEntity" rows="1" cols="60" maxlength="60"></textarea>
        <validation-message [control]="otherEntity"></validation-message>
      </div>
    </div>
  </div>
  <div class="row">

    <div class="col-sm-4">
      <div class="form-group">
        <label for="StartDate" [class.disabled]="origin==='AC'"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.StartDate' | translate}}</label>
        <div class="form-row">
          <div class="input-group col-sm-12">
            <input #dpStartDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                   placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                   [minDate]="minDate" [maxDate]="maxStartDate" [(ngModel)]="item.startDate" name="startDate"
                   (ngModelChange)="startAndEndDateValidator($event); changedStartDate();"
                   [disabled]="origin==='AC'"
                   maxlength="10"
                   #startDate="ngModel" required [clearRelated]="{model : this.item , propsToReset : ['endDate','missedDays','interpolatedWorkHours']} "
                   (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpStartDate)" />
            <div class="input-group-append disable-on-fieldset" (click)="!dpStartDate.isDisabled && dpStartDate.toggle()">
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <validation-message [control]="startDate"></validation-message>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="EndDate" [class.disabled]="origin==='AC' || item.startDate === undefined">
          <span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.EndDate' | translate}}
          <span *ngIf="nextBreak !== undefined" tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Data de fim limitada à data em que é obrigatório separar o período de tempo de serviço"></span>
        </label>
        <div class="form-row">
          <div class="input-group col-sm-12">
            <input #dpEndDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                   placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }" [minDate]="minEndDate"
                   [maxDate]="maxEndDate" [(ngModel)]="item.endDate" name="endDate" #endDate="ngModel" required
                   (ngModelChange)="startAndEndDateValidator($event); getBonus();"
                   [disabled]="origin==='AC' || item.startDate === undefined"
                   [clearRelated]="{model : this.item , propsToReset : ['missedDays','interpolatedWorkHours']} "
                   maxlength="10"
                   (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpEndDate)" />
            <div class="input-group-append disable-on-fieldset" (click)="!dpEndDate.isDisabled && dpEndDate.toggle()">
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <validation-message [control]="endDate"></validation-message>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="hasDiscounts" [class.disabled]="origin==='AC'"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.HasDiscounts' | translate}}</label>
        <fieldset [disabled]="origin==='AC'">
          <div class="btn-group btn-group-toggle">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==item.hasDiscounts" [class.disabled]="origin==='AC'" [radioLabel]="hasDiscounts">
              <input type="radio" [(ngModel)]="item.hasDiscounts" name="hasDiscounts" #hasDiscounts="ngModel" [value]="domain.value" required
                     [clearRelated]="{model : this.item , propsToReset : ['discountEntity']} ">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="ScheduleType" [class.disabled]="origin==='AC'"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.ScheduleType' | translate}}</label>
        <fieldset [disabled]="origin==='AC'">
          <select class="custom-select" [(ngModel)]="item.scheduleTypeCode" name="scheduleTypeCode"
                  (ngModelChange)="changedScheduleType($event)"
                  #scheduleTypeCode="ngModel"
                  [clearRelated]="{model : this.item , propsToReset : ['workHours', 'effectiveWorkHours']} " required
                  [dropdownTitle]="{value : item.scheduleTypeCode , dimensions : scheduleTypes }" nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of scheduleTypes" [value]="domain.code">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="scheduleTypeCode"></validation-message>
        </fieldset>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label [class.disabled]="!item.scheduleTypeCode || item.scheduleTypeCode =='C'">
          <span *ngIf="item.scheduleTypeCode && item.scheduleTypeCode!=='C'" class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.WorkHours' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.WorkHours' | translate}}"></span>
        </label>
        <input class="form-control" type="text" numeric="2.2"
               (ngModelChange)="changedWorkHours($event)"
               placeholder="{{'Placeholders.Generic.PartialHours' | translate}}"
               [clearRelated]="{model : this.item , propsToReset : ['effectiveWorkHours']} "
               [disabled]="!item.scheduleTypeCode || item.scheduleTypeCode ==='C'"
               [required]="item.scheduleTypeCode && item.scheduleTypeCode!=='C'"
               [(ngModel)]="item.workHours" name="workHours" #workHours="ngModel"
               minValue="1" maxValue="99" required>
        <validation-message [control]="workHours"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label [class.disabled]="!item.scheduleTypeCode || item.scheduleTypeCode =='C'">
          <span class="mandatory" *ngIf="!(!item.scheduleTypeCode ||( item.scheduleTypeCode != 'PS'  && item.scheduleTypeCode != 'PD'))">*</span>
          {{'CardEffectivityMap.EffectivityTableEdit.EffectiveWorkHours' | translate}}<span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.EffectiveWorkHours' | translate}}"></span>
        </label>
        <input class="form-control" type="text" numeric="2.2"
               placeholder="{{'Placeholders.Generic.PartialHours' | translate}}"
               [(ngModel)]="item.effectiveWorkHours" name="effectiveWorkHours" #effectiveWorkHours="ngModel"
               [required]="!item.scheduleTypeCode || item.scheduleTypeCode !='C'"
               [disabled]="!item.scheduleTypeCode || item.scheduleTypeCode ==='C'" minValue="1" [maxValue]="item.workHours">
        <validation-message [control]="effectiveWorkHours"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">


    <div class="col-sm-4">
      <div class="form-group">
        <label [class.disabled]="!item.startDate || !item.endDate || origin==='AC'">
          {{'CardEffectivityMap.EffectivityTableEdit.InterpolatedWorkHours'| translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.InterpolatedWorkHours' | translate}}"></span>
        </label>
        <input class="form-control" type="text" [numeric]="getRangeLegth()"
               placeholder="{{'Placeholders.Generic.Number' | translate}}"
               [(ngModel)]="item.interpolatedWorkHours" name="interpolatedWorkHours" #interpolatedWorkHours="ngModel"
               [maxValue]="getNumberOfDaysInRange()" [minValue]="0" [disabled]="!item.startDate || !item.endDate || origin==='AC'">
        <validation-message [control]="interpolatedWorkHours"></validation-message>
      </div>
    </div>

    <div class="col-sm-4" *ngIf="!item.interpolatedWorkHours">
      <div class="form-group">
        <label for="AllowancePlan" [class.disabled]="item.interpolatedWorkHours || origin==='AC'">
          Regime de abono
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique o Regime de abono aplicável"></span>
        </label>
        <select class="custom-select"
                [(ngModel)]="item.allowancePlan"
                name="allowancePlan_{{editIndex}}_1"
                #allowancePlan="ngModel"
                [dropdownTitle]="{value : item.allowancePlan }"
                [disabled]="item.interpolatedWorkHours || origin==='AC'"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getAllowancePlans()" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="allowancePlan"></validation-message>
      </div>
    </div>

    <div class="col-sm-4" *ngIf="item.interpolatedWorkHours">
      <div class="form-group">
        <label for="AllowancePlan" [class.disabled]="!item.interpolatedWorkHours  || origin==='AC'">
          <span *ngIf="item.interpolatedWorkHours !== undefined" class="mandatory">*</span>Regime de abono
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique o Regime de abono aplicável"></span>
        </label>
        <select class="custom-select"
                [(ngModel)]="item.allowancePlan"
                name="allowancePlan_{{editIndex}}_2"
                #allowancePlan="ngModel"
                [dropdownTitle]="{value : item.allowancePlan }"
                [required]="'required'"
                [disabled]="!item.interpolatedWorkHours || origin==='AC'"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getAllowancePlans()" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="allowancePlan"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="MissedDays" [class.disabled]="!item.startDate || !item.endDate || origin === 'AC'">
          {{'CardEffectivityMap.EffectivityTableEdit.MissedDays' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.MissedDays' | translate}}"></span>
        </label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.Generic.Number' | translate}}"
               [numeric]="getRangeLegth()" [(ngModel)]="item.missedDays" name="missedDays" #missedDays="ngModel" [maxValue]="getNumberOfDaysInRange()" [minValue]="0"
               [disabled]="!item.startDate || !item.endDate || origin === 'AC'">
        <validation-message [control]="missedDays"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="SubscriberSituation" [class.disabled]="origin==='AC'">{{'CardEffectivityMap.EffectivityTableEdit.SubscriberSituation' | translate}}</label>
        <select class="custom-select" [(ngModel)]="item.subscriberSituationCode" name="subscriberSituationCode"
                #subscriberSituationCode="ngModel"
                [disabled]="origin === 'AC'"
                [dropdownTitle]="{value : item.subscriberSituationCode, dimensions : subscriberSituations }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getSubscriberSituations()" [value]="domain.value" [disabled]="origin !== 'AC' && domain.value === 'SMAC'">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="subscriberSituationCode"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label [class.disabled]="origin==='AC'" for="TimeIncrease"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.TimeIncrease' | translate}}</label>
        <fieldSet [disabled]="origin==='AC'">
          <div class="btn-group btn-group-toggle">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==item.timeIncrease" [class.disabled]="origin==='AC'" [radioLabel]="timeIncrease ">
              <input type="radio" [(ngModel)]="item.timeIncrease" name="timeIncrease" [value]="domain.value" #timeIncrease="ngModel" [attr.disabled]="origin==='AC'?true:null" required
                     (ngModelChange)="timeIncreaseOnChange($event)"
                     [clearRelated]="(isCTorICE()) ? {model : this.item , propsToReset : ['remunerationTypeCode','value', 'bonus', 'numberOfDays', 'bonusDescription', 'percentage', 'hasIncreasePercentage']} : {model : this.item , propsToReset : ['remunerationTypeCode','value', 'bonus', 'numberOfDays', 'bonusDescription', 'percentage']}">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldSet>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="HasIncreasePercentage" [class.disabled]="!getTimeIncrease() || origin==='AC'">
          <span class="mandatory" *ngIf="getTimeIncrease()">*</span>{{'CardEffectivityMap.EffectivityTableEdit.HasIncreasePercentage' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.HasIncreasePercentage' | translate}}"></span>
        </label>
        <fieldSet [disabled]="!getTimeIncrease() || origin==='AC'">
          <div class="btn-group btn-group-toggle">

            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle"
                   [class.active]="domain.value==item.hasIncreasePercentage" [radioLabel]="hasIncreasePercentage">
              <input type="radio" [(ngModel)]="item.hasIncreasePercentage" name="hasIncreasePercentage" #hasIncreasePercentage="ngModel"
                     [value]="domain.value" [required]="getTimeIncrease()"
                     [clearRelated]="(item.hasIncreasePercentage?.toString() === 'true')? {model : this.item , propsToReset : ['remunerationTypeCode','value', 'bonus', 'numberOfDays', 'bonusDescription', 'percentage']} : ''" />
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldSet>
      </div>
    </div>
  </div>

  <div class="row">
    <div *ngIf="professionalClass !== '14' && professionalClass !== '12'" class="col-sm-12">
      <div class="form-group">
        <label for="Bonus" [class.disabled]="item.origin === 'AC' || item.timeIncrease !=='true' || item.hasIncreasePercentage !=='true'">
          <span *ngIf="item.timeIncrease ==='true' && item.hasIncreasePercentage ==='true' && item.origin !== 'AC'" class="mandatory">*</span>
          Bonificação
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique a bonificação aplicável."></span>
        </label>
        <select class="custom-select" [(ngModel)]="item.bonus" name="bonus"
                (ngModelChange)="bonusOnChange($event)"
                #bonus="ngModel"
                [required]="item.timeIncrease ==='true' && item.hasIncreasePercentage ==='true' && item.origin !== 'AC'"
                [disabled]="item.origin === 'AC' || item.timeIncrease !=='true' || item.hasIncreasePercentage !=='true'"
                [dropdownTitle]="{value : item.bonus }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of bonusList" [ngValue]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="bonus"></validation-message>
      </div>
    </div>

    <div *ngIf="professionalClass === '14' || professionalClass === '12'" class="col-sm-12">
      <div class="form-group">
        <label for="Bonus" [class.disabled]="item.origin === 'AC' || item.timeIncrease !=='true'">
          <span *ngIf="item.timeIncrease ==='true'" class="mandatory">*</span>
          Bonificação
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique a bonificação aplicável."></span>
        </label>
        <select class="custom-select" [(ngModel)]="item.bonus" name="bonus"
                (ngModelChange)="bonusOnChange($event)"
                #bonus="ngModel"
                [required]="item.timeIncrease ==='true' && item.origin !== 'AC'"
                [disabled]="item.origin === 'AC' || item.timeIncrease !=='true'"
                [dropdownTitle]="{value : item.bonus }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of bonusList" [ngValue]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="bonus"></validation-message>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="form-group">
        <!--<label for="BonusDescription" [class.disabled]="((professionalClass !=='14' && professionalClass !=='12') && item.origin === 'AC') || ((professionalClass !=='14' && professionalClass !=='12') && item.origin !== 'AC' && (item.timeIncrease !=='true' || item.hasIncreasePercentage !=='true'))">Descritivo da bonificação</label>-->
        <textarea class="form-control" id="bonusDescription" [(ngModel)]="item.bonusDescription"
                  #bonusDescription="ngModel"
                  name="bonusDescription" rows="3" cols="60" maxlength="250" readonly style="overflow: hidden; max-height:100px"></textarea>
        <validation-message [control]="bonusDescription"></validation-message>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-2">
      <div class="form-group-top">
        <label [class.disabled]="item.bonus === undefined || item.bonus === null || bonusInDays.toString() === 'true' || item.timeIncrease?.toString() !== 'true' || origin==='AC'">
          <span class="mandatory" *ngIf="item.bonus !== undefined && item.bonus !== null && bonusInDays.toString() !== 'true' && (item.timeIncrease?.toString() === 'true' && item.hasIncreasePercentage?.toString() === 'true') && origin!=='AC'">*</span>
          {{'CardEffectivityMap.EffectivityTableEdit.Percentage' | translate}}
        </label>
        <div class="position-relative">
          <input class="form-control input-right" type="text"
                 placeholder="{{'Placeholders.Generic.Percentage' | translate}}"
                 [(ngModel)]="item.percentage" name="percentage" percentage
                 minValue="0" maxValue="100" maxlength="6"
                 messageFieldType="percentage"
                 [disabled]="item.bonus === undefined || item.bonus === null || bonusInDays.toString() === 'true' || item.timeIncrease?.toString() !== 'true' || origin==='AC'"
                 [required]="item.bonus !== undefined && item.bonus !== null && bonusInDays.toString() !== 'true' && (item.timeIncrease?.toString() === 'true' && item.hasIncreasePercentage?.toString() === 'true') && origin!=='AC'" />
          <span class="input-icon-span-right">%</span>
          <validation-message [control]="percentage"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-2">
      <div class="form-group-top">
        <label for="NumberOfDays" [class.disabled]="item.bonus === undefined || item.bonus === null || bonusInDays.toString() !== 'true' || item.timeIncrease?.toString() !== 'true' || origin==='AC'">
          <span *ngIf="item.bonus !== undefined && item.bonus !== null && bonusInDays.toString() === 'true' && (item.timeIncrease?.toString() === 'true' && item.hasIncreasePercentage?.toString() === 'true') && origin!=='AC'" class="mandatory">*</span>Nº Dias
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indicar caso Bonificação seja em Dias"></span>
        </label>
        <div class="position-relative">
          <input class="form-control" type="number" [(ngModel)]="item.numberOfDays" name="numberOfDays" title="Indicar caso Bonificação seja em Dias" #numberOfDays="ngModel" numeric="3" placeholder="000"
                 [disabled]="item.bonus === undefined || item.bonus === null || bonusInDays.toString() !== 'true' || item.timeIncrease?.toString() !== 'true' || origin==='AC'"
                 [required]="item.bonus !== undefined && item.bonus !== null && bonusInDays.toString() === 'true' && (item.timeIncrease?.toString() === 'true' && item.hasIncreasePercentage?.toString() === 'true') && origin!=='AC'" />
          <validation-message [control]="numberOfDays"></validation-message>
        </div>
      </div>
    </div>
  </div>
  <div class="row">

    <div class="col-sm-8">
      <div class="form-group-top">
        <label [class.disabled]="origin==='AC'">{{'CardEffectivityMap.EffectivityTableEdit.Category' | translate}}</label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardEffectivityMap.EffectivityTableEdit.Category' | translate}}"
               [(ngModel)]="item.category" name="category" #category="ngModel"
               [disabled]="origin==='AC'"
               maxlength="30">
        <validation-message [control]="category"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group-top">
        <label [class.disabled]="origin==='AC'">
          <span class="mandatory" *ngIf="bonusWithQuota && getTimeIncrease() && getHasIncreasePercentage() && origin!=='AC' && !isOverlappedWithLiquidityDate()">*</span>Remuneração Total
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique a remuneração ilíquida total do período."></span>
        </label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency [(ngModel)]="item.value" name="value" #value="ngModel"
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [required]="bonusWithQuota && getTimeIncrease() && getHasIncreasePercentage() && origin!=='AC' && !isOverlappedWithLiquidityDate()"
                 [disabled]="origin==='AC'?true:false">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="value"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <span *ngIf="!tableItemEditForm.valid && !isEdit" class="text-danger validation_error_all">{{'Generic.ValidationErrorCardAll' | translate}}</span>
</form>

<form *ngIf="!isVersion2()" name="tableItemEditForm" #tableItemEditForm="ngForm">
  <div class="row">
    <div class="col-sm-8">
      <div class="form-group">
        <label for="Entity"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.Entity' | translate}}</label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardEffectivityMap.EffectivityTableEdit.Entity' | translate}}"
               [(ngModel)]="item.entity" name="entity" #entity="ngModel" maxlength="60"
               required>
        <validation-message [control]="entity"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="StartDate"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.StartDate' | translate}}</label>
        <div class="form-row">
          <div class="input-group col-sm-12">
            <input #dpStartDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                   placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                   [minDate]="minDate" [maxDate]="item.endDate || maxDate" [(ngModel)]="item.startDate" name="startDate" maxlength="10"
                   #startDate="ngModel" required [clearRelated]="{model : this.item , propsToReset : ['missedDays','interpolatedWorkHours']} "
                   (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange(dpStartDate)" />
            <div class="input-group-append disable-on-fieldset" (click)="!dpStartDate.isDisabled && dpStartDate.toggle()">
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <validation-message [control]="startDate"></validation-message>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="row">

    <div class="col-sm-4">
      <div class="form-group">
        <label for="EndDate"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.EndDate' | translate}}</label>
        <div class="form-row">
          <div class="input-group col-sm-12">
            <input #dpEndDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                   placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }" [minDate]="item.startDate"
                   [maxDate]="maxDate" [(ngModel)]="item.endDate" name="endDate" #endDate="ngModel" required maxlength="10"
                   [clearRelated]="{model : this.item , propsToReset : ['missedDays','interpolatedWorkHours']} "
                   (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpEndDate)" />
            <div class="input-group-append disable-on-fieldset" (click)="!dpEndDate.isDisabled && dpEndDate.toggle()">
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <validation-message [control]="endDate"></validation-message>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label>
          <span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.WorkHours' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.WorkHours' | translate}}"></span>
        </label>
        <input class="form-control" type="text" numeric="2.2"
               (ngModelChange)="changedWorkHours($event)"
               placeholder="{{'Placeholders.Generic.PartialHours' | translate}}"
               [clearRelated]="{model : this.item , propsToReset : ['effectiveWorkHours']} "
               [(ngModel)]="item.workHours" name="workHours" #workHours="ngModel"
               minValue="1" maxValue="99" required>
        <validation-message [control]="workHours"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="ScheduleType"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.ScheduleType' | translate}}</label>
        <select class="custom-select" [(ngModel)]="item.scheduleTypeCode" name="scheduleTypeCode"
                (ngModelChange)="changedScheduleType($event)"
                #scheduleTypeCode="ngModel" required
                [clearRelated]="{model : this.item , propsToReset : ['effectiveWorkHours']} "
                [dropdownTitle]="{value : item.scheduleTypeCode , dimensions : scheduleTypes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of scheduleTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="scheduleTypeCode"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label [class.disabled]="!item.scheduleTypeCode ||( item.scheduleTypeCode != 'PS'  && item.scheduleTypeCode != 'PD')">
          <span class="mandatory" *ngIf="!(!item.scheduleTypeCode ||( item.scheduleTypeCode != 'PS'  && item.scheduleTypeCode != 'PD'))">*</span>
          {{'CardEffectivityMap.EffectivityTableEdit.EffectiveWorkHours' | translate}}<span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.EffectiveWorkHours' | translate}}"></span>
        </label>
        <input class="form-control" type="text" numeric="2.2"
               placeholder="{{'Placeholders.Generic.PartialHours' | translate}}"
               [(ngModel)]="item.effectiveWorkHours" name="effectiveWorkHours" #effectiveWorkHours="ngModel"
               [required]="!(!item.scheduleTypeCode ||( item.scheduleTypeCode != 'PS'  && item.scheduleTypeCode != 'PD'))"
               [disabled]="!item.scheduleTypeCode ||( item.scheduleTypeCode != 'PS'  && item.scheduleTypeCode != 'PD')" minValue="1" [maxValue]="item.workHours">
        <validation-message [control]="effectiveWorkHours"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label [class.disabled]="!item.startDate || !item.endDate">
          {{'CardEffectivityMap.EffectivityTableEdit.InterpolatedWorkHours'| translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.InterpolatedWorkHours' | translate}}"></span>
        </label>
        <input class="form-control" type="text" [numeric]="getRangeLegth()"
               placeholder="{{'Placeholders.Generic.Number' | translate}}"
               [(ngModel)]="item.interpolatedWorkHours" name="interpolatedWorkHours" #interpolatedWorkHours="ngModel"
               [maxValue]="getNumberOfDaysInRange()" [minValue]="0" [disabled]="!item.startDate || !item.endDate">
        <validation-message [control]="interpolatedWorkHours"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="MissedDays" [class.disabled]="!item.startDate || !item.endDate">
          {{'CardEffectivityMap.EffectivityTableEdit.MissedDays' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.MissedDays' | translate}}"></span>
        </label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.Generic.Number' | translate}}"
               [numeric]="getRangeLegth()" [(ngModel)]="item.missedDays" name="missedDays" #missedDays="ngModel" [maxValue]="getNumberOfDaysInRange()" [minValue]="0"
               [disabled]="!item.startDate || !item.endDate">
        <validation-message [control]="missedDays"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">

    <div class="col-sm-4" *ngIf="!origin==='AC'">
      <div class="form-group">
        <label for="HasDiscounts"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.HasDiscounts' | translate}}</label>
        <div class="btn-group btn-group-toggle">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==item.hasDiscounts" [radioLabel]="hasDiscounts">
            <input type="radio" [(ngModel)]="item.hasDiscounts" name="hasDiscounts_{{editIndex}}_" #hasDiscounts="ngModel" [value]="domain.value" required
                   [clearRelated]="{model : this.item , propsToReset : ['discountEntity']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="hasDiscounts" [class.disabled]="origin==='AC'"><span *ngIf="!origin==='AC'" class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.HasDiscounts' | translate}}</label>
        <div class="btn-group btn-group-toggle">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==item.hasDiscounts" [class.disabled]="origin==='AC'" [radioLabel]="hasDiscounts">
            <input type="radio" [(ngModel)]="item.hasDiscounts" name="hasDiscounts" #hasDiscounts="ngModel" [value]="domain.value" [attr.disabled]="origin==='AC'?true:null" required
                   [clearRelated]="{model : this.item , propsToReset : ['discountEntity']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>
    <div class="col-sm-8">
      <div class="form-group">
        <label for="DiscountEntity" [class.disabled]="!item.hasDiscounts || item.hasDiscounts?.toString() != 'true'">
          <span class="mandatory" *ngIf="item.hasDiscounts && item.hasDiscounts?.toString() == 'true'">*</span>
          {{'CardEffectivityMap.EffectivityTableEdit.DiscountEntity' | translate}}
        </label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardEffectivityMap.EffectivityTableEdit.DiscountEntity' | translate}}"
               [(ngModel)]="item.discountEntity" name="discountEntity"
               #discountEntity="ngModel" maxlength="60" [required]="item.hasDiscounts && item.hasDiscounts?.toString() == 'true'" [disabled]="!item.hasDiscounts || item.hasDiscounts?.toString() != 'true'">
        <validation-message [control]="discountEntity"></validation-message>
      </div>
    </div>
  </div>


  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="SubscriberSituation">{{'CardEffectivityMap.EffectivityTableEdit.SubscriberSituation' | translate}}</label>
        <select class="custom-select" [(ngModel)]="item.subscriberSituationCode" name="subscriberSituationCode"
                #subscriberSituationCode="ngModel"
                [dropdownTitle]="{value : item.subscriberSituationCode, dimensions : subscriberSituations }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of subscriberSituations" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="subscriberSituationCode"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="TimeIncrease"><span class="mandatory">*</span>{{'CardEffectivityMap.EffectivityTableEdit.TimeIncrease' | translate}}</label>
        <div class="btn-group btn-group-toggle">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==item.timeIncrease" [radioLabel]="timeIncrease ">
            <input type="radio" [(ngModel)]="item.timeIncrease" name="timeIncrease" [value]="domain.value" #timeIncrease="ngModel" required
                   [clearRelated]="{model : this.item , propsToReset : ['percentage','hasIncreasePercentage','remunerationTypeCode','value']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label [class.disabled]="!getTimeIncrease()"><span class="mandatory" *ngIf="getTimeIncrease()">*</span>{{'CardEffectivityMap.EffectivityTableEdit.Percentage' | translate}}</label>
        <div class="position-relative">
          <input class="form-control input-right" type="text" percentage
                 placeholder="{{'Placeholders.Generic.Percentage' | translate}}"
                 [(ngModel)]="item.percentage" name="percentage" #percentage="ngModel"
                 minValue="0" maxValue="100" maxlength="6"
                 messageFieldType="percentage" [required]="getTimeIncrease()" [disabled]="!getTimeIncrease()">
          <span class="input-icon-span-right">%</span>
          <validation-message [control]="percentage"></validation-message>
        </div>
      </div>
    </div>

  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">

        <label for="HasIncreasePercentage" [class.disabled]="!getTimeIncrease()">
          <span class="mandatory" *ngIf="getTimeIncrease()">*</span>{{'CardEffectivityMap.EffectivityTableEdit.HasIncreasePercentage' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.HasIncreasePercentage' | translate}}"></span>
        </label>
        <fieldSet [disabled]="!getTimeIncrease()">
          <div class="btn-group btn-group-toggle">

            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle"
                   [class.active]="domain.value==item.hasIncreasePercentage" [radioLabel]="hasIncreasePercentage">
              <input type="radio" [(ngModel)]="item.hasIncreasePercentage" name="hasIncreasePercentage" #hasIncreasePercentage="ngModel"
                     [value]="domain.value" [required]="getTimeIncrease()"
                     [clearRelated]="{model : this.item , propsToReset : ['remunerationTypeCode','value']} " />
              {{domain.description}}
            </label>

            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldSet>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label [class.disabled]="!getTimeIncrease() || (getTimeIncrease() && !getHasIncreasePercentage())">
          <span class="mandatory" *ngIf="getTimeIncrease() && getHasIncreasePercentage()">*</span>{{'CardEffectivityMap.EffectivityTableEdit.RemunerationType' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.RemunerationType' | translate}}"></span>
        </label>

        <select class="custom-select" [(ngModel)]="item.remunerationTypeCode" name="remunerationTypeCode"
                #remunerationTypeCode="ngModel"
                [required]="getTimeIncrease() && getHasIncreasePercentage()"
                [disabled]="!getTimeIncrease() || (getTimeIncrease() && !getHasIncreasePercentage())"
                [dropdownTitle]="{value : item.remunerationTypeCode, dimensions : remunerationTypes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of remunerationTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="remunerationTypeCode"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label [class.disabled]="origin==='CT' && ( !getTimeIncrease() || (getTimeIncrease() && !getHasIncreasePercentage()))">
          <span class="mandatory" *ngIf="getTimeIncrease() && getHasIncreasePercentage()">*</span>{{'CardEffectivityMap.EffectivityTableEdit.Value' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardEffectivityMap.Value' | translate}}"></span>
        </label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency [(ngModel)]="item.value" name="value" #value="ngModel"
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [required]="getTimeIncrease() && getHasIncreasePercentage()"
                 [disabled]="(origin==='CT' && ( !getTimeIncrease() || (getTimeIncrease() && !getHasIncreasePercentage())))?'disabled':''">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="value"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <div class="row">

    <div class="col-sm-8">
      <div class="form-group">
        <label>{{'CardEffectivityMap.EffectivityTableEdit.Category' | translate}}</label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardEffectivityMap.EffectivityTableEdit.Category' | translate}}"
               [(ngModel)]="item.category" name="category" #category="ngModel"
               maxlength="30">
        <validation-message [control]="category"></validation-message>
      </div>
    </div>
  </div>

  <span *ngIf="!tableItemEditForm.valid && !isEdit" class="text-danger validation_error_all">{{'Generic.ValidationErrorCardAll' | translate}}</span>

</form>

<div class="d-flex justify-content-between mt-4 mb-2">
  <button type="button" class="btn btn-outline-primary disable-on-fieldset" (click)="onRemove(isEdit)"><span
    [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span><span>{{isEdit ?  'Remover' : 'Cancelar'}}</span></button>
  <button type="button" aria-label="Aplicar" class="btn btn-primary disable-on-fieldset" (click)="onEdit(isEdit)"><span
      class="icon-check"></span><span>Aplicar</span></button>
</div>
